/**
 * Tippy の `appendTo` に渡す描画先。通常は body 直下に出し、ホバーカード等の
 * 中（別の Tippy の内側）に置かれた要素では、その Tippy のルート要素の中へ出す。
 *
 * Tippy は自身のルート要素の中にある `[data-tippy-root]` を入れ子のポップアップ
 * として扱い、そこへポインタが移っても外側を閉じない。body 直下に出すと
 * 入れ子と認識されず、内側のカードへ移った瞬間に外側（と一緒に内側）が閉じる。
 */
export const appendToTippyContainer = (reference: Element): Element =>
  reference.closest("[data-tippy-root]") ?? document.body;
